<template>
  <div class="wrap headerWrap">
    <el-row class="logoRow" type="flex" align="middle">
      <el-col :xs="12" :sm="21" :md="21">
        <el-row type="flex" align="middle">
          <router-link to="/"
            ><el-image
              src="logo.png"
              fit="contain"
              class="logo"
              @click="openNav(false)"
            ></el-image
          ></router-link>

          <el-menu
            :default-active="activeIndex"
            class="menuBox animate__animated"
            :class="{
              animate__slideInRight: showMenu,
              animate__slideOutRight: !showMenu,
            }"
            :mode="menuMode"
            background-color="#2a2a2a"
            text-color="#fff"
            active-text-color="#d71820"
            :router="true"
            v-show="showMenu"
            :unique-opened="true"
          >
            <el-menu-item index="/" @click="openNav(false)">
              <router-link to="/">HOME</router-link></el-menu-item
            >

            <el-submenu index="1">
              <template slot="title">ABOUT US</template>
              <el-menu-item index="/about/my" @click="openNav(false)"
                >BRIEF INTRODUCTION</el-menu-item
              >
              <el-menu-item index="/about/culture" @click="openNav(false)"
                >CORPORATE CULTURE</el-menu-item
              >
              <el-menu-item index="/leaders" @click="openNav(false)"
                >MANAGEMENT</el-menu-item
              >
              <el-menu-item index="/development" @click="openNav(false)"
                >DEVELOPMENT HISTORY</el-menu-item
              >
              <el-menu-item index="/developmentplan" @click="openNav(false)"
                >DEVELOPMENT PLAN</el-menu-item
              >

            </el-submenu>

            <el-submenu index="2">
              <template slot="title">PRODUCT</template>
              <!-- <el-menu-item
                index="/product"
                @click="openNav(false)"
                >R&D CORE</el-menu-item
              > -->
              <el-menu-item
                index="/productIntroduce/top"
                @click="openNav(false)"
                >PRODUCTS</el-menu-item
              >
              <el-menu-item
                index="/productIntroduce/two"
                @click="openNav(false)"
                >QUALITY ASSURANCE</el-menu-item
              >
            </el-submenu>

            <el-menu-item index="/use/one" @click="openNav(false)">APPLICATION</el-menu-item>

            <el-menu-item index="/honor" @click="openNav(false)">REPUTATION</el-menu-item>
            <el-menu-item index="/news/company" @click="openNav(false)">NEWS</el-menu-item>
            <el-menu-item index="/contact" @click="openNav(false)">CONTACT US</el-menu-item>
          </el-menu>
        </el-row>
      </el-col>

      <el-col :xs="12" :sm="3" :md="3">
        <el-row type="flex" justify="end" align="middle" class="headerRight">
          <span class="headerS"
            ><router-link to="/search"
              ><i class="el-icon-search"></i></router-link
          ></span>
          <span class="lang">
            <em :class="{ on: lang == 'zh' }" @click="changeLang('zh')">CN</em>
            /
            <em :class="{ on: lang == 'en' }" @click="changeLang('en')">EN</em>
          </span>
          <!-- <span>股票代码 <br />600000</span> -->
          <div class="navBox">
            <svg
              @click="openNav(true)"
              v-if="showNav"
              data-v-c569994e=""
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="4"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
              <rect
                x="2"
                y="11"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
              <rect
                x="2"
                y="18"
                width="20"
                height="1"
                stroke="currentColor"
                stroke-linecap="square"
              ></rect>
            </svg>
            <svg
              v-else
              @click="openNav(false)"
              data-v-c569994e=""
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6366 11.7784L19.7077 4.70735L19.0006 4.00024L11.9295 11.0713L4.85847 4.00024L4.15137 4.70735L11.2224 11.7784L4.15137 18.8495L4.85847 19.5566L11.9295 12.4855L19.0006 19.5566L19.7077 18.8495L12.6366 11.7784Z"
                stroke="currentColor"
                stroke-linecap="square"
              ></path>
            </svg>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { judgeWindow } from "@/utils/tool.js";
import cookie from "cookiejs";

export default {
  data() {
    return {
      activeIndex: this.$route.path || "",
      showNav: true,
      menuMode: "horizontal",
      showMenu: true,
      screenWidth: document.body.clientWidth,
      lang: this.$global.lang,
      menus:[],
    };
  },
  methods: {
    openNav(boo) {
      if (judgeWindow()) {
        this.menuMode = "vertical";
        this.showNav = !boo;
        this.showMenu = boo;
      }
    },
    changeW() {
      if (judgeWindow()) {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
    },
    changeLang(value) {
      
      this.$global.changeLang(value);
      this.$router.push('/')
      // this.$router.go(0);
      location.reload()
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.activeIndex = this.$route.path;
      }
    );
  },
  /*  watch: {
    screenWidth(val) {
      console.log("val", val);
      this.screenWidth = val;
    },
  }, */
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    this.activeIndex = this.$route.path;
    this.changeW();
    this.$api.getMenu().then((res) => {
      const {
        MenuInfos
      } = res.Value;
      this.menus = MenuInfos;
      console.log(this.menuList,"++menu")
    });
    window.onresize = () => {
      this.changeW();
    };

    // cookie("lang", "en");
  },
};
</script>

<style lang="scss">
.headerWrap {
  min-height: 60px;
  .lang{
    em{cursor: pointer;}
  }
  .animate__animated.animate__slideInRight,
  .animate__animated.animate__slideOutRight {
    --animate-duration: 0.2s;
  }
  .el-menu--collapse .el-menu .el-submenu,
  .el-submenu__title i {
    display: none !important;
  }
  .el-menu-item.is-active {
    color: #fff !important;
    font-weight: bold;
  }
  .is-active {
    .el-submenu__title {
      color: #fff !important;
      font-weight: bold;
    }
  }
  .el-carousel__button {
    width: 40px;
    height: 4px;
  }
  .el-submenu__title:hover {
    font-size: bold;
  }
  .el-menu--horizontal > .el-submenu:focus,
  .el-menu--horizontal > .el-submenu:hover {
    font-weight: bold;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    font-weight: bold;
  }
  em {
    font-style: normal;
  }
}
.el-menu--popup {
  min-width: 95px !important;
}
.el-menu--popup-bottom-start {
  margin-top: 0 !important;
}
.navBox {
  text-align: right;
  display: none;
}
.navMask {
  position: fixed;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 0;
  background: #fff;
}
.en{
  .el-submenu__title{
    padding:0 10px;
  }
}
@media screen and (max-width:1320px) {
  .headerWrap {
  .el-menu-item{
    padding:0 15px;
  }
}
}
@media screen and (max-width:1260px) {
  .headerWrap {
  .el-menu-item{
    padding:0 5px;
  }
}
}
</style>